import { toKebabCase } from "../../helpers";
import { removeMarkdownSyntax } from "../../external";
var HEADING_PREFIX = /\n(#+\s*)(.*)/g;
var CODE_BLOCKS_REGEX = /^(([ \t]*`{3,4})([^\n]*)([\s\S]+?)(^[ \t]*\2))/gm;
var TABS_BLOCKS_REGEX = /<div\s+tabs\s*?(name=('|").+('|"))?\s*?>(.|\n)*?<\/div>/g;

function decrementLevels(headers, level) {
  if (level === void 0) {
    level = -1;
  }

  for (var _i = 0, headers_1 = headers; _i < headers_1.length; _i++) {
    var header = headers_1[_i];
    var l = level === -1 ? Number(header.level) - 1 : level;
    header.level = String(Number(header.level) - l);

    if (l && header.children && header.children.length) {
      header.children = decrementLevels(header.children, l);
    }
  }

  return headers;
}

var getHeaders = function getHeaders(source, headerPrefix, customFirstNode) {
  var headings = new Set();
  var content = source.rawContent.replace(TABS_BLOCKS_REGEX, "").replace(CODE_BLOCKS_REGEX, "");
  content = "\n" + content;
  var headers = [];

  if (!content) {
    return headers;
  }

  var lastIndexes = new Array(6).fill(null); // array of references

  var matchedHeaders = content.match(HEADING_PREFIX);

  if (!matchedHeaders || !matchedHeaders.length) {
    return customFirstNode ? [customFirstNode] : headers;
  }

  for (var _i = 0, matchedHeaders_1 = matchedHeaders; _i < matchedHeaders_1.length; _i++) {
    var header = matchedHeaders_1[_i];
    var level = (header.match(/#/g) || []).length;
    var title = header.replace(/#/g, "");
    title = removeMarkdownSyntax(title).trim();
    var id = headerPrefix ? headerPrefix + "-" + title : title;

    if (headings.has(id)) {
      if (/[1-9]$/.test(id)) {
        id = id + "-" + (Number(id[id.length - 1]) + 1);
      } else {
        id = id + "-1";
      }
    }

    headings.add(id);
    var h = {
      title: title,
      level: String(level),
      id: toKebabCase(id),
      source: source
    };
    lastIndexes[level - 1] = h;
    var occurrence = level - 2;

    if (level === 1 || !lastIndexes[occurrence]) {
      headers.push(h);
      continue;
    }

    h.parent = lastIndexes[occurrence];

    if (lastIndexes[occurrence].children) {
      lastIndexes[occurrence].children.push(h);
    } else {
      lastIndexes[occurrence].children = [h];
    }
  }

  var decrementedHeaders = decrementLevels(headers);

  if (!customFirstNode) {
    return decrementedHeaders;
  }

  customFirstNode.children = decrementedHeaders;

  for (var _a = 0, decrementedHeaders_1 = decrementedHeaders; _a < decrementedHeaders_1.length; _a++) {
    var h = decrementedHeaders_1[_a];
    h.parent = customFirstNode;
  }

  return [customFirstNode];
};

export var extractHeaders = function extractHeaders(_a) {
  var source = _a.source,
      options = _a.options;
  var hp = "";
  var customNode;

  if (options) {
    var _b = options.headerPrefix,
        headerPrefix = _b === void 0 ? "" : _b,
        customFirstNode = options.customFirstNode;
    hp = typeof headerPrefix === "function" ? headerPrefix(source) : headerPrefix;
    customNode = customFirstNode && customFirstNode(source, toKebabCase);
  }

  var headers = getHeaders(source, hp, customNode).filter(function (h) {
    return h.title;
  });
  return {
    headers: headers
  };
};